import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Trash2, Minus, Plus } from 'lucide-react';
import { toast } from 'sonner';
import { useCart } from '@/context/CartContext';
import { useLanguage } from '@/i18n/LanguageContext';

import { API } from '@/lib/apiBase';

export const CartPrintRow = ({ item }) => {
  const { removePrintItem, updatePrintQuantity } = useCart();
  const { t } = useLanguage();

  return (
    <Card key={item.key} className="bg-card border-border">
      <CardContent className="p-4">
        <div className="flex gap-4">
          <div className="w-20 h-20 rounded-sm overflow-hidden flex-shrink-0">
            <img
              src={`${API}/photos/${item.photo_id}/preview?size=thumb`}
              alt={t('common.photoAlt')}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="font-semibold text-sm">{t('prints.physicalPrint')}</h3>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {item.format_name} — CHF {item.format_price?.toFixed(2)}
                </p>
              </div>
              <Button
                variant="ghost" size="icon"
                onClick={() => { removePrintItem(item.key); toast.info(t('cart.removeFromCart')); }}
                className="text-muted-foreground hover:text-destructive h-8 w-8"
                data-testid={`remove-print-${item.key}`}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
            <div className="flex items-center justify-between mt-2">
              <div className="flex items-center gap-2">
                <Button
                  variant="outline" size="icon"
                  className="h-7 w-7"
                  onClick={() => updatePrintQuantity(item.key, item.quantity - 1)}
                  data-testid={`qty-minus-${item.key}`}
                >
                  <Minus className="w-3 h-3" />
                </Button>
                <span className="font-mono text-sm w-6 text-center">{item.quantity}</span>
                <Button
                  variant="outline" size="icon"
                  className="h-7 w-7"
                  onClick={() => updatePrintQuantity(item.key, item.quantity + 1)}
                  data-testid={`qty-plus-${item.key}`}
                >
                  <Plus className="w-3 h-3" />
                </Button>
              </div>
              <div className="font-mono text-base font-bold text-primary">
                CHF {(item.format_price * item.quantity).toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
